export default new DataCollector();
import { i18n } from '@/plugins/i18n';
// duplicated local/templates/youtravel/src/js/globals/DataCollector.js
/*eslint-disable */
var VIEW_TOUR_ITEM_PAGE_TYPES = {
  serp: 'serp',
  tour: 'tour',
  expert: 'expert',
  blog: 'blog',
  home: 'home',
  favorites: 'favorites',
  widget: 'widget',
  about: 'about',
  unknown: 'unknown'
};

function normalizeTourListPath(pathname, lang) {
  var path = pathname || '/';
  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    path = path.slice(0, queryIndex);
  }
  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    path = path.slice(0, hashIndex);
  }

  path = stripTourListLanguagePrefix(path, lang);

  if (path.length > 1 && path.charAt(path.length - 1) === '/') {
    path = path.slice(0, -1);
  }

  return path || '/';
}

function stripTourListLanguagePrefix(path, lang) {
  var strippedByLang = stripTourListPrefix(path, lang);
  if (strippedByLang !== null) {
    return strippedByLang;
  }

  var match = path.match(/^\/(en|ru)(\/.*)?$/);
  if (!match) {
    return path;
  }

  var rest = match[2] || '/';
  if (isKnownTourListPath(rest)) {
    return rest;
  }

  return path;
}

function stripTourListPrefix(path, lang) {
  if (!lang) {
    return null;
  }

  var prefix = '/' + lang;
  if (path === prefix || path === prefix + '/') {
    return '/';
  }
  if (path.indexOf(prefix + '/') === 0) {
    return path.slice(prefix.length) || '/';
  }

  return null;
}

function isKnownTourListPath(path) {
  var normalized = path || '/';
  if (normalized.length > 1 && normalized.charAt(normalized.length - 1) === '/') {
    normalized = normalized.slice(0, -1);
  }

  if (normalized === '/') {
    return true;
  }

  return normalized === '/about'
    || normalized.indexOf('/about/') === 0
    || normalized === '/expert'
    || normalized.indexOf('/expert/') === 0
    || normalized === '/lk/my'
    || normalized.indexOf('/lk/my/') === 0
    || isTourListFavoritesPath(normalized)
    || normalized === '/blog'
    || normalized.indexOf('/blog/') === 0
    || normalized === '/blog-author'
    || normalized.indexOf('/blog-author/') === 0
    || normalized === '/blog_lp'
    || normalized.indexOf('/blog_lp/') === 0
    || normalized === '/widgets'
    || normalized.indexOf('/widgets/') === 0
    || normalized === '/tours'
    || normalized.indexOf('/tours/') === 0;
}

function isTourListFavoritesPath(path) {
  return path === '/lk/mytours/favorites'
    || path.indexOf('/lk/mytours/favorites/') === 0
    || path === '/tours/favorites';
}

function resolveTourListPageType(pathname, lang) {
  var path = normalizeTourListPath(pathname, lang);

  if (path === '/' || path === '/index.php') {
    return VIEW_TOUR_ITEM_PAGE_TYPES.home;
  }
  if (path === '/about' || path.indexOf('/about/') === 0) {
    return VIEW_TOUR_ITEM_PAGE_TYPES.about;
  }
  if (isTourListFavoritesPath(path)) {
    return VIEW_TOUR_ITEM_PAGE_TYPES.favorites;
  }
  if (path === '/expert' || path.indexOf('/expert/') === 0 || path === '/lk/my' || path.indexOf('/lk/my/') === 0) {
    return VIEW_TOUR_ITEM_PAGE_TYPES.expert;
  }
  if (
    path === '/blog' || path.indexOf('/blog/') === 0
    || path === '/blog-author' || path.indexOf('/blog-author/') === 0
    || path === '/blog_lp' || path.indexOf('/blog_lp/') === 0
  ) {
    return VIEW_TOUR_ITEM_PAGE_TYPES.blog;
  }
  if (path === '/widgets' || path.indexOf('/widgets/') === 0) {
    return VIEW_TOUR_ITEM_PAGE_TYPES.widget;
  }
  if (path === '/tours' || path.indexOf('/tours/') === 0) {
    var rest = path === '/tours' ? '' : path.slice('/tours/'.length);
    var firstSegment = rest.split('/')[0];
    if (firstSegment && /^\d+$/.test(firstSegment)) {
      return VIEW_TOUR_ITEM_PAGE_TYPES.tour;
    }
    return VIEW_TOUR_ITEM_PAGE_TYPES.serp;
  }

  return VIEW_TOUR_ITEM_PAGE_TYPES.unknown;
}

function getViewTourItemContext(location, lang) {
  var currentLocation = location || {};
  var href = typeof currentLocation.href === 'string' ? currentLocation.href : '';

  return {
    href: href,
    page_type: resolveTourListPageType(currentLocation.pathname || '/', lang)
  };
}

function DataCollector(){
  let _self = this;
  let user_agent = "";

  this._request = async function(payload){
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest();
      xhr.open('POST', '/api/v2/data/collect');
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.responseType = 'json';
      xhr.send(JSON.stringify([payload]));

      xhr.onload = function() {
        let responseObj = xhr.response;
        if (xhr.status !== 200) { // анализируем HTTP-статус ответа, если статус не 200, то произошла ошибка
          reject(responseObj)
        } else { // если всё прошло гладко, выводим результат
          resolve(responseObj);
        }
      };
    })
  }

  this.setCookie = function(name, value, options = {}){
    options = {
      path: '/',
      secure: true,
      // при необходимости добавьте другие значения по умолчанию
      ...options
    };

    if (options.expires instanceof Date) {
      options.expires = options.expires.toUTCString();
    }

    let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

    for (let optionKey in options) {
      updatedCookie += "; " + optionKey;
      let optionValue = options[optionKey];
      if (optionValue !== true) {
        updatedCookie += "=" + optionValue;
      }
    }

    document.cookie = updatedCookie;
  }

  this.getCookie = function(name) {
    let matches = document.cookie.match(new RegExp(
      "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }

  this._getRef = function(){
    return _self.getCookie('ref') || "";
  }

  this._getUtm = function(){
    let utm = _self.getCookie('utm') || "";
    if(utm !== "") {
      return JSON.parse('{"' + utm.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) {
        return key === "" ? value : decodeURIComponent(value)
      });
    }
    return false;
  }

  //generates random id;
  this.guid = () => {
    let s4 = () => {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + s4() +  s4() + s4() + s4() + s4() + s4();
  }

  // Ключ воронки: cookie yt_funnel_session_id (32 символа [0-9a-f], окно 30 минут бездействия),
  // общая для Nuxt, шаблона bitrix и сервера. Читается заново на каждом событии, без долгой памяти.
  this._newFunnelSessionId = function(){
    try {
      if(window.crypto && typeof window.crypto.getRandomValues === 'function'){
        let bytes = new Uint8Array(16);
        window.crypto.getRandomValues(bytes);
        let id = '';
        for(let n = 0; n < bytes.length; n++){
          id += (bytes[n] < 16 ? '0' : '') + bytes[n].toString(16);
        }
        return id;
      }
    } catch (e) {}
    return _self.guid();
  }

  this._isFunnelSessionId = function(value){
    return typeof value === 'string' && /^[0-9a-f]{32}$/.test(value);
  }

  // Запасной ключ воронки, пока cookie не пишется: память страницы (window.__ytWindowState.fsid),
  // затем sessionStorage['yt_funnel_session_id'] вкладки (ключи как у Nuxt). Окно 30 минут
  // бездействия остаётся: просроченный ключ не воскрешается.
  this._fallbackFunnelSessionId = function(now){
    let state = _self._windowState();
    let id = state.fsid;
    let touchedAt = state.fsidAt;
    if(!_self._isFunnelSessionId(id)){
      id = null;
      touchedAt = 0;
      try {
        id = window.sessionStorage.getItem('yt_funnel_session_id');
        touchedAt = Number(window.sessionStorage.getItem('yt_funnel_session_ts')) || 0;
      } catch (e) {}
    }
    if(!_self._isFunnelSessionId(id)){
      return null;
    }
    return (touchedAt > 0 && now - touchedAt > 1800000) ? null : id;
  }

  this._touchFunnelSession = function(){
    let state = _self._windowState();
    let now = Date.now();
    let id;
    try {
      id = _self.getCookie('yt_funnel_session_id');
    } catch (e) {
      id = undefined;
    }
    if(!_self._isFunnelSessionId(id)){
      id = _self._newFunnelSessionId();
    }

    let persisted = false;
    try {
      let cookie = 'yt_funnel_session_id=' + id + '; path=/; max-age=1800; samesite=lax';
      if(window.location && window.location.protocol === 'https:'){
        cookie += '; secure';
      }
      document.cookie = cookie;
      persisted = _self.getCookie('yt_funnel_session_id') === id;
    } catch (e) {}

    if(!persisted){
      // Cookie заблокирована: один ключ на страницу и вкладку, а не новый на каждое событие.
      let fallback = _self._fallbackFunnelSessionId(now);
      if(fallback){
        id = fallback;
      }
      try {
        window.sessionStorage.setItem('yt_funnel_session_id', id);
        window.sessionStorage.setItem('yt_funnel_session_ts', String(now));
      } catch (e) {}
    }

    state.fsid = id;
    state.fsidAt = now;
    return id;
  }

  // window_id: идентификатор вкладки, 32 символа [0-9a-f]. Хранится в sessionStorage['yt_window_id']
  // (один origin: Nuxt и страницы шаблона bitrix в одной вкладке видят один id), читается на каждом событии.
  // Копия вкладки наследует sessionStorage, поэтому дубль ловится через BroadcastChannel('yt_window_id').
  // Состояние общее для всех экземпляров коллектора на странице: глобальный и vue-плагин живут вместе,
  // а BroadcastChannel доставляет сообщения и другим каналам той же страницы.
  this._windowState = function(){
    if(!window.__ytWindowState){
      window.__ytWindowState = {id: null, started: false, helloAt: 0, channel: null, lifecycle: false, hidden: false, fsid: null, fsidAt: 0};
    }
    return window.__ytWindowState;
  }

  this._setWindowId = function(id){
    _self._windowState().id = id;
    try {
      window.sessionStorage.setItem('yt_window_id', id);
    } catch (e) {}
  }

  // Текущий id без создания нового: sessionStorage, а если он недоступен или пуст, id из памяти страницы.
  this._peekWindowId = function(){
    let id = null;
    try {
      id = window.sessionStorage.getItem('yt_window_id');
    } catch (e) {
      id = null;
    }
    if(!id || !/^[0-9a-f]{32}$/.test(id)){
      id = _self._windowState().id;
    }
    return (id && /^[0-9a-f]{32}$/.test(id)) ? id : null;
  }

  this._getWindowId = function(){
    let id = _self._peekWindowId();
    if(!id){
      id = _self._newFunnelSessionId();
    }
    _self._setWindowId(id);
    return id;
  }

  // Закрывает канал окон: открытый BroadcastChannel не пускает страницу в back/forward cache.
  this._closeWindowChannel = function(){
    let state = _self._windowState();
    let channel = state.channel;
    state.channel = null;
    state.helloAt = 0;
    try {
      if(channel){
        channel.close();
      }
    } catch (e) {}
  }

  // Один раз за загрузку страницы: канал закрывается на pagehide, а после возврата из bfcache
  // (pageshow с persisted) поднимается заново лениво, на следующем событии, с новым hello.
  this._installWindowGuardLifecycle = function(){
    let state = _self._windowState();
    if(state.lifecycle){
      return;
    }
    state.lifecycle = true;
    window.addEventListener('pagehide', function(){
      state.hidden = true;
      _self._closeWindowChannel();
    });
    window.addEventListener('pageshow', function(event){
      state.hidden = false;
      if(!event || !event.persisted){
        return;
      }
      _self._closeWindowChannel();
      state.started = false;
    });
  }

  // Один раз за показ страницы: hello с текущим id; вкладка с тем же id отвечает taken,
  // и получивший taken в течение 2 секунд после своего hello берёт новый id.
  // Канал закрывается на pagehide и после pageshow с persisted создаётся заново (см. выше).
  this._initWindowGuard = function(){
    let state = _self._windowState();
    if(state.started || state.hidden){
      return;
    }
    state.started = true;
    try {
      if(typeof window.BroadcastChannel !== 'function'){
        return;
      }
      let channel = new window.BroadcastChannel('yt_window_id');
      state.channel = channel;
      _self._installWindowGuardLifecycle();
      channel.onmessage = function(event){
        try {
          let msg = event && event.data;
          let current = _self._peekWindowId();
          if(!msg || !current || msg.id !== current){
            return;
          }
          if(msg.t === 'hello'){
            channel.postMessage({t: 'taken', id: current});
          } else if(msg.t === 'taken' && state.helloAt > 0 && Date.now() - state.helloAt <= 2000){
            _self._setWindowId(_self._newFunnelSessionId());
          }
        } catch (e) {}
      };
      let id = _self._peekWindowId();
      if(id){
        state.helloAt = Date.now();
        channel.postMessage({t: 'hello', id: id});
      }
    } catch (e) {}
  }

  this._touchWindowId = function(){
    try {
      let id = _self._getWindowId();
      _self._initWindowGuard();
      return id;
    } catch (e) {
      return _self.guid();
    }
  }

  this.trackEvent = function(category, event, payload){
    // user_id только если страница сказала, что пользователь авторизован (header.php): cookie
    // BITRIX_SM_USER_BX_ID живёт 365 дней и не очищается при выходе, гость слал бы старый id.
    let user_id = window.__ytUserAuthorized === true ? _self.getCookie('BITRIX_SM_USER_BX_ID') : undefined;
    let guest_id = _self.getCookie('BX_USER_ID');
    let gclid = _self.getCookie('gclid');

    if(!guest_id){
      guest_id = _self.guid();
      let date = new Date(Date.now() + 365*86400000);
      _self.setCookie('BX_USER_ID', guest_id, {expires: date.toUTCString()})
    }

    payload.lang = i18n.locale;
    if(!!gclid){
      payload.gclid = gclid;
    }

    if(!!_self._getRef()){
      payload.ref = _self._getRef() || "";
    }

    if(!!window && !!fakeWindow.location){
      payload.location = fakeWindow.location
    }

    if (category === 'Tour list' && (event === 'View Tour item' || event === 'Click Tour item')) {
      var currentLocation = (typeof fakeWindow !== 'undefined' && fakeWindow.location) ? fakeWindow.location : {};
      var viewContext = getViewTourItemContext(currentLocation, i18n.locale);
      if (event === 'View Tour item') {
        payload.href = viewContext.href;
      }
      payload.page_type = viewContext.page_type;
    }

    if(typeof fakeWindow.amplitudeUserProperties != "undefined"){
      payload.amplitudeUserProps = fakeWindow.amplitudeUserProperties;
    }

    let data = {
      'user_id': parseInt(user_id),
      'guest_id': guest_id,
      'user_agent': _self.user_agent,
      'utm': JSON.stringify(_self._getUtm()) || "",
      'event_category': category,
      'event_action': event,
      'event_payload': JSON.stringify(payload),
      'funnel_session_id': _self._touchFunnelSession(),
      'window_id': _self._touchWindowId(),
      'timestamp': Math.floor(Date.now() / 1000)
    };

    _self._request(data)
      .then((result) => {});
  }

  this._init = function(){
    _self.user_agent = typeof navigator != "undefined" ? navigator.userAgent : "";
  }
  _self._init();
}

youtravel = youtravel || {};
if(typeof youtravel.DataCollector == "undefined"){
  youtravel.DataCollector = new DataCollector();
}
